import ActionType from "../../../isp._comun/iu/reductores/ActionType";
export default class ActionTypePlan extends ActionType {}
